import React from 'react';
import { Link } from 'react-router-dom';

import { COMPANY_NAME, CONTACT_EMAIL } from '../config/contact';

import './SiteContact.scss';

// Who runs Jookable and how to reach them, under the page footers. YouTube's API policies
// ask for contact information where users can find it, not only inside the legal pages.
const SiteContact = () => (
  <div className="site-contact">
    Run by {COMPANY_NAME} &middot; <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a> &middot;{' '}
    <Link to="/terms">Terms</Link> &middot; <Link to="/privacy">Privacy</Link>
  </div>
);

export default SiteContact;
